import React from 'react';
import { StoreMap, stores } from '../components/map/StoreMap';
import { KPICard } from '../components/ui/KPICard';
import { Star, MessageSquare, Store } from 'lucide-react';
export function HeatmapPage() {
  return <div className="flex flex-col h-[calc(100vh-64px)]" data-id="element-496">
      {/* KPI Overlay / Header Area */}
      <div className="px-6 py-6 bg-edeka-light z-10" data-id="element-497">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-498">
          <KPICard title="Anzahl Filialen" value={stores.length.toString()} icon={<Store size={18} data-id="element-500" />} data-id="element-499" />
          <KPICard title="Ø Bewertungs-Score" value="4,3" icon={<Star size={18} data-id="element-502" />} data-id="element-501" />
          <KPICard title="Bewertungen gesamt" value="8.420" icon={<MessageSquare size={18} data-id="element-504" />} data-id="element-503" />
        </div>
      </div>

      {/* Map Area */}
      <div className="flex-1 relative border-t border-gray-200" data-id="element-505">
        <StoreMap data-id="element-506" />
      </div>
    </div>;
}